/** Created by azhou on 2019/1/16.*/
<template>
  <div class="register-input" >
            <el-autocomplete
            :style="{width:width+'px'}"
            class="inline-input"
            v-model="valueInside"
            :fetch-suggestions="querySearch"
            placeholder="请输入名称"
            @select="handleSelect"
            ></el-autocomplete>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'BgGreyInput',
    props: {
        value: {},
        width: {
            type: Number,
            default:358
        },
        type: {
            type: String,
            default: 'text'
        },
        placeholder: {
            type: String
        },
        labelText: {
            type: String,
            default: ''
        },
        restaurants: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
      return {
        valueInside: '',
      };
    },
    watch: {
        value() {
        this.valueInside = this.value;
        this.$emit('input',this.value) 
        },
        valueInside() {
        this.$emit('input',this.valueInside) 
        }
    },
    methods: {
      querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
        handleSelect(item) {
            console.log(item);
        }
    }
  }
</script>
<style lang="scss" scoped>
  .register-input {
    display: flex;
    align-items: center;
    .input-label {
      width: 70px;
      margin-right: 10px;
      display: inline-block;
      text-align-last: justify;
      font-size: 14px;
    }
  }
</style>
